export default __webpack_public_path__ + "static/media/pacemaker.bc8625da.pdf";